import { ORDER_TYPES, PROVIDERS } from '../constants.js'
import { getUrlWithOrderId, joinUrl, omitUndefinedValues } from '../utils.js'
import { ENABLED_ASSETS, PAYMENT_METHOD_NAMES } from './constants.js'
import blockchainAdapter from './adapter.js'

export const getWidgetUrl = async ({
  apiKey,
  appId,
  assets: assets_ = ENABLED_ASSETS,
  sign,
  fromAmount,
  fromAsset,
  finalUrl,
  orderId,
  origin,
  paymentMethod = PAYMENT_METHOD_NAMES.card,
  toAsset = [],
  type = ORDER_TYPES.buy,
  url = 'https://blockchain.com/pay/widget',
  walletAddress,
} = {}) => {
  if (!apiKey) {
    throw new Error('`apiKey` is required')
  }

  if (type !== ORDER_TYPES.buy) {
    throw new Error('Only `buy` orders are accepted')
  }

  if (finalUrl && typeof sign !== 'function') {
    throw new Error('`sign` function is required when using `finalUrl`')
  }

  const toAsset_ = Array.isArray(toAsset) ? toAsset[0] : toAsset
  if (walletAddress && !toAsset_) {
    throw new Error('`toAsset` is required when using `walletAddress`')
  }

  if (walletAddress && typeof sign !== 'function') {
    throw new Error('`sign` function is required when using `walletAddress`')
  }

  const redirectUrl = finalUrl
    ? getUrlWithOrderId(
        orderId,
        finalUrl,
        omitUndefinedValues({ provider: PROVIDERS.blockchain, origin })
      )
    : undefined

  let redirectUrlSignature
  let walletAddressSignature
  if (sign) {
    ;[redirectUrlSignature, walletAddressSignature] = await Promise.all([
      redirectUrl
        ? sign({ data: encodeURIComponent(redirectUrl), provider: PROVIDERS.blockchain })
        : undefined,
      walletAddress ? sign({ data: walletAddress, provider: PROVIDERS.blockchain }) : undefined,
    ])
  }

  const [baseCurrency] = blockchainAdapter.fromExodusToProviderAsset(toAsset_, assets_)

  const parameters = omitUndefinedValues({
    apiKey,
    baseCurrency,
    externalReference: orderId,
    quoteCurrency: fromAsset,
    quoteCurrencyAmount: fromAmount,
    paymentMethod,
    subPartnerId: appId,
    ...(redirectUrlSignature
      ? {
          redirectUrl,
          redirectUrlSignature,
        }
      : undefined),
    ...(walletAddressSignature
      ? {
          walletAddress,
          walletAddressSignature,
        }
      : undefined),
  })

  return joinUrl(url, `?${new URLSearchParams(parameters)}`)
}
